import { render, staticRenderFns } from "./RoomInformation.vue?vue&type=template&id=2d0f1337&scoped=true&"
import script from "./RoomInformation.vue?vue&type=script&lang=js&"
export * from "./RoomInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0f1337",
  null
  
)

export default component.exports